export const CategoryCardSkeleton = () => {
  return (
    <div className="rounded-[8px] bg-white shadow-md flex flex-col items-start h-[120px] w-full relative animate-pulse">

      <div className="flex flex-col h-full w-full p-4">
        <div className="flex items-start justify-between w-full">
          {/* Skeleton pentru icon */}
          <div className="bg-gray-200 rounded-lg h-[50px] w-[50px]"></div>
        </div>

        {/* Skeleton pentru nume categorie */}
        <div className="mt-auto">
          <div className="bg-gray-200 h-5 w-3/4 rounded"></div>
        </div>
      </div>
    </div>
  );
};